import React, { useEffect, useState } from "react";
import HomeHighlightsContent from "./HomeHighlightsContent.mjs";
import "./HomeHighlights.css";

export default function HomeHighlights() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    fetch("/content/blog/posts.json", { cache: "no-store", signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error("Highlights unavailable");
        return response.json();
      })
      .then((data) => {
        if (!controller.signal.aborted) setPosts(data);
      })
      .catch(() => {
        // Optional editorial content must not block the product homepage.
      });
    return () => controller.abort();
  }, []);

  return <HomeHighlightsContent posts={posts} />;
}
